<script setup lang="ts">
import { computed } from 'vue';
import { iconMap, type IconName, type IconSize } from './Icon.types';

export interface IconProps {
  name: IconName;
  size?: IconSize;
  filled?: boolean;
}

const props = withDefaults(defineProps<IconProps>(), {
  size: 'md',
  filled: false,
});

const sizeValues: Record<IconSize, number> = {
  sm: 16,
  md: 20,
  lg: 24,
  xl: 28,
};

const iconComponent = computed(() => iconMap[props.name] ?? null);
const pixelSize = computed(() => sizeValues[props.size]);
</script>

<template>
  <component
    :is="iconComponent"
    v-if="iconComponent"
    :size="pixelSize"
    :stroke-width="filled ? 2.5 : 2"
    :class="['inline-flex shrink-0 select-none']"
    aria-hidden="true"
    role="img"
  />
  <span
    v-else
    class="inline-flex shrink-0 select-none items-center justify-center text-on-surface-muted"
    :style="{ width: `${pixelSize}px`, height: `${pixelSize}px`, fontSize: `${pixelSize * 0.5}px` }"
    aria-hidden="true"
    role="img"
    :title="`Missing icon: ${name}`"
    >?</span
  >
</template>
